import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import Careers from './components/pages/Careers';
import OurWork from './components/pages/Our-Work';
import Footer from './components/Footer';
import History from './components/pages/History';
import ScrollToTop from './components/ScrollToTop';
import Approach from './components/pages/Approach';
import ProjectPage from './components/pages/ProjectsPage';
import JobPage from './components/JobPages';
import ApplySuccess from './components/pages/ApplySuccess';
import ContactUs from './components/Contact-Us';

function App() {
  return (
    <Router>
      <div className="app-shell">
        <ScrollToTop />
        <Navbar />

        <main className="site-main">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Services */}
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<Services />} /> {/* NEW: path param */}

            {/* Careers */}
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/jobs/:jobId" element={<JobPage />} />

            {/* Our Work */}
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/our-work/:projectSlug" element={<ProjectPage />} />   {/* slug route */}
            <Route path="/our-work/id/:projectId" element={<ProjectPage />} />  {/* optional fallback */}

            {/* Company */}
            <Route path="/history" element={<History />} />
            <Route path="/approach" element={<Approach />} />

            {/* Misc */}
            <Route path="/apply/success" element={<ApplySuccess />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
